import React, { Component } from 'react';

import './Addresses.css';
import ListAddresses from './ListAddresses';
import EditAddress from './EditAddress';
import AddAddress from './AddAddress';

class AddressForm extends Component {

    isFormBlank(array) {
        let retBool = true;
        array.forEach(row => {
            if (row.value !== null && row.value !== '') { retBool = false; }
        })
        return retBool;
    }

    render() {
        return (<>
            {(this.props.justAdd == null || !this.props.justAdd) && this.props.addresses.map((row, rowIndex) => (
                <div key={row.linkedID}>
                    {this.props.editID !== row.linkedID ? (
                        <ListAddresses {...this.props} row={row}
                        />
                    ) : (
                        <EditAddress {...this.props} row={row}
                            isFormBlank={this.isFormBlank}
                        />
                    )
                    }
                    {(rowIndex < this.props.addresses.length - 1) ? <hr className='border-dark' /> : <></>}
                </div>
            ))}
            {((this.props.justAdd)) ? (
                <AddAddress {...this.props}
                    isFormBlank={this.isFormBlank}
                />
            ) : (<></>)}

        </>
        );

    }

}

export default AddressForm;
